export const ErrorPage = () => {
  return (
    <div className="container m-5">
      <h1>Oops!</h1>
      <h2>Algo não saiu como o planejado.</h2>
      <p>
        Ir para <a href="/#">página inicial</a>.
      </p>
    </div>
  );
};
